import { render, staticRenderFns } from "./electricmeter.vue?vue&type=template&id=3423fc82&scoped=true&"
import script from "./electricmeter.vue?vue&type=script&lang=js&"
export * from "./electricmeter.vue?vue&type=script&lang=js&"
import style0 from "./electricmeter.vue?vue&type=style&index=0&id=3423fc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423fc82",
  null
  
)

export default component.exports